import React from 'react';
import PropTypes from 'prop-types';
import './EditableTableCell.css'

class EditableDropdownCell extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {editing: true, version:0};
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }



    handleClick (e) {
        //e.preventDefault()
        //this.setState({editable:true});
    }

    handleChange(e) {
      this.props.column.onValueChange({
        rowData: this.props.rowData,
        rowIndex: this.props.rowIndex,
        column: this.props.column,
        value: e.target.value
      });
      // this.setState({version: this.state.version+1});
    }

    render() {
        var inputField = null;
        var {cellData, column} = this.props;
        //console.log(cellData)
        if (this.state.editing) {
            let options = [(<option key="unselected" value=""></option>)];
            for (var i = 0; i < column.lov.length; i++) {
              let opt = column.lov[i]
              options.push(<option key={opt.name} value={opt.name}>{opt.label}</option>)
            }

            inputField = <select onChange={this.handleChange} value={cellData}>
              {options}
            </select>
        } else {
            inputField = cellData;
        }

        return (
            <div onClick={this.handleClick}
                 className={(this.state.editing?"EditableTableCellWithInput":"EditableTableCell")}
                 key={""+this.props.rowIndex+":"+this.props.columnIndex}
                 >
                { inputField }
            </div>

        );
    }
}



EditableDropdownCell.propTypes = {
  column: PropTypes.shape({
    onValueChange: PropTypes.func.isRequired,
    lov: PropTypes.array.isRequired
  }),
  container: PropTypes.any.isRequired,
  rowIndex: PropTypes.number.isRequired,
  rowData: PropTypes.object.isRequired,
  columnIndex: PropTypes.number.isRequired,
  // editing: PropTypes.bool.isRequired,
  cellData: PropTypes.any
};


export default EditableDropdownCell;